import { useEffect, useState } from "react";
import "components/ThankYouKickout/thankYouKickout.scss";
import { getThankYouKickoutPage } from "services/get-thankYouKickoutPage";
import { useNavigate, useSearchParams } from "react-router-dom";
import { deleteAllShopCookies } from "utils";
import { cartState } from "atoms";
import { useSetRecoilState } from "recoil";

const ThankYouKickout = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [thankYouErrorMessage, setThankYouErrorMessage] = useState("");
  const setCart = useSetRecoilState(cartState);

  useEffect(() => {
    deleteAllShopCookies();
    const fetchThankyouKickoutPage = async () => {
      const kickoutReason: string | null = searchParams.get("reason");
      const getThankYouKickoutPageResponse = await getThankYouKickoutPage(kickoutReason);
      const links = getThankYouKickoutPageResponse["_links"];
      const windowLocation = "ec:windowLocation";

      if (getThankYouKickoutPageResponse._embedded) {
        if (getThankYouKickoutPageResponse._embedded["ec:cart"]) {
          const cart = getThankYouKickoutPageResponse._embedded["ec:cart"];
          setCart(cart);
        }
        if (getThankYouKickoutPageResponse._embedded["ec:errorHtml"]) {
          setThankYouErrorMessage(getThankYouKickoutPageResponse._embedded["ec:errorHtml"]);
        }
      } else if (links) {
        navigate(links[windowLocation].href);
      }
    };
    fetchThankyouKickoutPage();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    deleteAllShopCookies();
    window.scroll(0, 0);
  });

  return (
    <div className="thank-you-kickout-container">
      {!thankYouErrorMessage ? (
        <>
          <div className="thank-you-content">
            <h2>
              We're sorry! We need a little more information from you. Please call <a href="tel:888-403-2667">888-403-2667</a> to complete your order.
            </h2>
            <h3 className="mt-5">Thanks!</h3>
          </div>
        </>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: thankYouErrorMessage }} className="thank-you-content" />
      )}
      <div className="btn-container">
        <button className="back-button mt-3 mb-5" onClick={() => navigate("/")}>
          Back to Comporium.com
        </button>
      </div>
    </div>
  );
};

export default ThankYouKickout;
